import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FUNDING_SOURCE_BASE_PATH } from '../../../../../features/funding/source/funding-source-routing';

// This route exists just to provide breadcrumbs for the funding source subpages.
export const Route = createFileRoute('/_app/_clearing-core/funding/source/_source')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'funding-source',
        label: 'Funding',
        to: FUNDING_SOURCE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
